<template>
  <div v-if="banners.length" class="info-banners row">
    <div
      v-for="banner in banners"
      v-if="activeOnPage(banner)"
      :key="banner.id"
      class="info-banner col-lg-12"
      :style="{ backgroundColor: banner.background_color || '#f9fafb' }"
    >
      <div class="info-banner__content" v-html="banner.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBanner",
  props: {
    page: String,
  },
  computed: {
    banners() {
      return this.$store.getters.infoBanners || [];
    },
  },
  methods: {
    activeOnPage(banner) {
      const current = (banner.active_pages || []).find(
        (page) => page.value === this.page
      );
      return current ? current.is_active : false;
    },
  },
};
</script>

<style>
.info-banner {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  word-break: break-word;
}

.info-banner__content {
  width: 100%;
}

.info-banner__content a {
  text-decoration: underline;
}

.info-banner__content * {
  margin: 0;
  padding: 0;
}
@media (max-width: 767px) {
  .info-banner {
    font-size: 18px;
  }
}
</style>
